export default __webpack_public_path__ + "9d94f5bef4f668a91ea196b1618e0fcc.glb";